import { Injectable } from '@angular/core';
import { ITitle } from '../../../shared/interfaces/title';
import { ModalFeeInterface } from '../../../../app-old-buyer/interfaces/modal-fee.interface';
import { ITariffs } from '../interfaces/operation-payload';

@Injectable({
  providedIn: 'root',
})
export class PurchaseStateService {
  private installmentRepurchase: IStateInstallments = { all: [], selected: [] };
  private installments: IStateInstallments = { all: [], selected: [] };
  private netValue: number = 0;
  private tariffs: ITariffs | null = null;
  private totalFaceValue: number | null = null;
  private selectedValue: number | null = null;
  private availableLimit: number | null = null;

  constructor() {}

  public getInstallmentRepurchase(): IStateInstallments {
    return this.installmentRepurchase;
  }

  public setInstallmentRepurchase(all: ITitle[], selected: ITitle[]): void {
    this.installmentRepurchase = {
      all: all,
      selected: selected,
    };
  }

  public getInstallments(): IStateInstallments {
    return this.installments;
  }

  public setInstallments(all: ITitle[], selected: ITitle[]): void {
    this.installments = {
      all: all,
      selected: selected,
    };
  }

  public setNetValue(netValue: number) {
    this.netValue = netValue;
  }

  public getNetValue() {
    return this.netValue;
  }

  public setTariffs(tariffs: ITariffs) {
    this.tariffs = tariffs;
  }

  public getTariffs() {
    return this.tariffs;
  }

  public getTotalFaceValue() {
    return this.totalFaceValue;
  }

  public setTotalFaceValue(totalFaceValue: number | null) {
    this.totalFaceValue = totalFaceValue;
  }

  public getSelectedValue() {
    return this.selectedValue;
  }

  public setSelectedValue(value: number | null) {
    this.selectedValue = value;
  }

  public getAvailableLimit() {
    return this.availableLimit;
  }

  public setAvailableLimit(value: number | null) {
    this.availableLimit = value;
  }

  public cleanAll() {
    this.installmentRepurchase = { all: [], selected: [] };
    this.installments = { all: [], selected: [] };
    this.netValue = 0;
    this.tariffs = null;
    this.totalFaceValue = null;
    this.selectedValue = null;
    this.availableLimit = null;
    /*
    console.log(
      'Purchase state cleaned',
      this.availableLimit,
      this.selectedValue,
      this.totalFaceValue,
      this.tariffs,
      this.netValue,
      this.installments,
      this.installmentRepurchase
    );
    */
  }
}

interface IStateInstallments {
  all: ITitle[];
  selected: ITitle[];
}
